import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios'
import Dialog from '@mui/material/Dialog';
import {
  DialogHeader,
  DialogHeading,
  GridLeft,
  GridRight,
  GridSection,
} from '../Episode.Styled';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Grid, IconButton, Typography } from '@mui/material';
import { useReactToPrint } from 'react-to-print';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { referalNote, dateFormatPdf, CONTACT_FORM_UPDATE_URL, EPISODE_AUTHORIZATION_LIST_URL } from '../../../constants';
import {
  referralNoteField,
  stopResponseSubGrid,
  referalPageCardHeading,
  ReferralFieldGrid,
} from './referalPageCommonUtils';
import { getStopApi } from '../../../services/StopApi/StopApi';

const InitialReferalPage = (props) => {
  const { open, setOpen, referralForm, user } = props;
  console.log('## referralForm')
  console.log(referralForm)

  const [SAPContact, setSAPContact] = useState({});
  const referalPdfForm = useSelector((state) => state?.referalPdfForm) ?? {};

  const newEpisodeReferenceData = useSelector((state) => state.newEpisodeReferenceData) ?? {};

  const [authData, setAuthData] = useState({});

  // console.log('### referralForm');
  // console.log(referralForm);

  // console.log('### referalPdfForm');
  // console.log(referalPdfForm);

  // console.log('### newEpisodeReferenceData');
  // console.log(newEpisodeReferenceData);

  // const {
  //   epdID = '',
  //   epdIcnCDC = '',
  //   epdIcnDateRelExp = '',
  //   epdPrl_CntID = '',
  //   prtDOB = '',
  //   prtKey = '',
  // } = referalPdfForm || {};

  const handleClose = () => {
    setOpen(false);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
      getSAPContact();
  }, [referalPdfForm]);

  useEffect(() => {
      fetchAuthList();
  }, [referralForm]);

  const getSAPContact = () => {
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const config = {
      headers: {
        Authorization: authorization,
        Region: process.env.REACT_APP_STOP_REGION,
      },
    };
    
    axios.get(`${CONTACT_FORM_UPDATE_URL}/${referalPdfForm.epdSigTrnCSM_CntID}`, config)
    .then((res) => {
      //console.log('### SAPContact');
      //console.log(res.data.data);
      setSAPContact(res.data.data);
    })
    .catch((error) => console.log(error));
  }

  const fetchAuthList = async () => {
    //console.log('### FETCH DATA (AUTH LIST) EPISODE AUTH');
    setAuthData((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${EPISODE_AUTHORIZATION_LIST_URL}/${referralForm.episodeID}/authList`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      const data = json?.map((item, index) => ({
          ...item,
          id: item.authId,
          authStartDate: item.authStartDate
            ? moment(item.authStartDate).format('MM/DD/YYYY').split('T')[0]
            : '-',
          overAllEndDate: item.overAllEndDate
            ? moment(item.overAllEndDate).format('MM/DD/YYYY').split('T')[0]
            : '-',
          modality: item.modality ? item.modality?.value : '-',
          communityBasedProvider: item.communityBasedProvider
            ? item.communityBasedProvider?.value
            : '-',
          cbpAdmitDate: item.cbpAdmitDate
            ? moment(item.cbpAdmitDate).format('MM/DD/YYYY').split('T')[0]
            : '-',
          cbpDischargeDate: item.cbpDischargeDate
            ? moment(item.cbpDischargeDate).format('MM/DD/YYYY').split('T')[0]
            : '-',
          dischargeReason: item.dischargeReason
            ? item.dischargeReason?.value
            : '-',
          totalTreatmentVerified: item.totalTreatmentVerified
            ? item.totalTreatmentVerified
            : '-',

          cboName: item.cboName,
          cboModId: item.cboModId,
          orgAdr: item.orgAdr,
          orgCity: item.orgCity,
          orgZip: item.orgZip,
          cntKey: item.cntKey,
          cntFax: item.cntFax,
          cntPhone: item.cntPhone,
        }));

      console.log('### authData');
      console.log(data);

      setAuthData(data);
    }).catch((e) => alert(e));
  };

  return (
    <Dialog fullScreen open={open} onClose={setOpen}>
      <DialogHeader>
        <DialogHeading variant="h5"></DialogHeading>
        <Box>
          <Button variant="contained" onClick={() => handlePrint()}>
            Print
          </Button>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogHeader>

      <Grid container ref={componentRef}>
        <GridSection mt={1} mx={2} container spacing={1}>
          <Grid item xs={10}>
            <Typography variant="h4">STOP Initial Referral</Typography>
          </Grid>

          <Grid item xs={2}>
            <Typography variant="h4">Episode ID : {referralForm.episodeID}</Typography>
          </Grid>

          <Grid item xs={12}>
            {referalNote}
          </Grid>
        </GridSection>

        <GridSection mt={1} mx={2} container spacing={1}>
          <ReferralFieldGrid xs={12} title="Date Sent : " defaultValue="" />
        </GridSection>

        <GridSection mx={2} container spacing={1}>
          <GridLeft item xs={6}>
            <Grid container>
              {referalPageCardHeading('Participant Information')}

              <ReferralFieldGrid
                xs={12}
                title="Name : "
                defaultValue={referalPdfForm.prtKey}
              />

              <ReferralFieldGrid
                xs={6}
                title="CDC No : "
                defaultValue={referalPdfForm.epdIcnCDC}
              />

              <ReferralFieldGrid
                xs={6}
                title="DOB : "
                defaultValue={referalPdfForm.prtDOB ? moment(referalPdfForm.prtDOB).format('MM/DD/YYYY') : ''}
              />

              <ReferralFieldGrid
                xs={12}
                title="Date of SAP Release : "
                defaultValue={referralForm.epdIcnDateRelExp ? moment(referralForm.epdIcnDateRelExp).format('MM/DD/YYYY') : ''}
              />

              <ReferralFieldGrid
                xs={12}
                title="County of Parole : "
                defaultValue={referralForm.countyofParole?.value}
              />
            </Grid>
          </GridLeft>

          <GridRight container item xs={6}>
            {referalPageCardHeading('SAP Information')}
            <ReferralFieldGrid
              xs={12}
              title="SAP Short Name : "
              defaultValue={newEpisodeReferenceData.referralSource.find(r => r.orgId==referalPdfForm.epdSap_OrgID).referralSource}
            />

            <ReferralFieldGrid xs={12} title="SAP ID : " defaultValue={referalPdfForm.epdSap_OrgID} />
            <ReferralFieldGrid
              xs={12}
              title="Contact Person : "
              defaultValue={SAPContact.cntKey}
            />
            <ReferralFieldGrid xs={6} title="Phone : " defaultValue={SAPContact.directPhone} />
            <ReferralFieldGrid xs={6} title="Fax : " defaultValue={SAPContact.fax} />
          </GridRight>
        </GridSection>

        <GridSection mx={2} container spacing={1}>
          <GridLeft container item xs={12}>
            {referalPageCardHeading('STOP Information')}

            <ReferralFieldGrid xs={10} title="STOP Area : " defaultValue={referalPdfForm.epdIcn_SscID} />

            <ReferralFieldGrid
              xs={10}
              title="Contact Person : "
              defaultValue={referralForm.sTOPPlacementCoordinator?.key}
            />

            <ReferralFieldGrid xs={5} title="Phone : " defaultValue={referralForm.sTOPPlacementCoordinator?.phone} />
            <ReferralFieldGrid xs={5} title="Fax : " defaultValue={referralForm.sTOPPlacementCoordinator?.fax} />
          </GridLeft>
        </GridSection>

        <GridSection mx={2} container spacing={1}>
          <GridLeft container item xs={6}>
            {referalPageCardHeading('Program')}
            <ReferralFieldGrid xs={10} title="CBP ID : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[0]?.refCboId : ''} />

            <ReferralFieldGrid xs={10} title="Program : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[0]?.refCboName : ''} />

            <ReferralFieldGrid xs={10} title="Modality : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[0]?.refMod : ''} />

            <ReferralFieldGrid xs={10} title="Address : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[0]?.refCboAddr : ''} />

            <ReferralFieldGrid xs={5} title="City : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[0]?.refCboCity : ''} />

            <ReferralFieldGrid xs={5} title="Zip : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[0]?.refCboZip : '' }/>

            <ReferralFieldGrid xs={10} title="Contact : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[0]?.refContact : ''} />

            <ReferralFieldGrid xs={10} title="Phone : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[0]?.refContactPhone : ''} />

            <ReferralFieldGrid xs={10} title="Fax : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[0]?.refContactFax : ''} />
          </GridLeft>

          <GridRight container item xs={6}>
            {referalPageCardHeading('Program')}
            <ReferralFieldGrid xs={10} title="CBP ID : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[1]?.refCboId : ''} />

            <ReferralFieldGrid xs={10} title="Program : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[1]?.refCboName : ''} />

            <ReferralFieldGrid xs={10} title="Modality : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[1]?.refMod : ''} />

            <ReferralFieldGrid xs={10} title="Address : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[1]?.orgAdr : ''} />

            <ReferralFieldGrid xs={5} title="City : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[1]?.orgCity : ''} />

            <ReferralFieldGrid xs={5} title="Zip : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[1]?.orgZip : ''} />

            <ReferralFieldGrid xs={10} title="Contact : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[1]?.refContact : ''} />

            <ReferralFieldGrid xs={10} title="Phone : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[1]?.refContactPhone : ''} />

            <ReferralFieldGrid xs={10} title="Fax : " defaultValue={referralForm.tblRefs ? referralForm.tblRefs[1]?.refContactFax : ''} />
          </GridRight>
        </GridSection>
        <GridSection mx={2} container spacing={1}>
          <GridLeft container item xs={12}>
            {referalPageCardHeading('Clinical Information')}
            <Grid item xs={12}>
              Please complete the bottom portion of this form and fax back to
              the SAP representative within three working days of this referral.
            </Grid>
            <Grid item xs={11.9}>
              Treatment Recommendations (include Special conditions) :
              {referralNoteField('', referralForm.clinicalInformationTreatmentRecommendations)}
              <Box my={2}></Box>
            </Grid>
          </GridLeft> 
        </GridSection>
        <GridSection mx={2} container spacing={1}>
          <GridLeft container item xs={12}>
            {referalPageCardHeading('STOP Response')}
            {stopResponseSubGrid(referralForm.sTOPResponse ? 'Yes, a conditional treatment slot is available on ' + moment(referralForm?.epdIcnDateRelExp).format(dateFormatPdf) : 'No, a conditional treatment slot is not available on ' + moment(referralForm?.epdIcnDateRelExp).format(dateFormatPdf))}
            {stopResponseSubGrid(referralForm.sTOPResponse ? 'Additional Information' : 'Explain: include alternative CBPs')}
            {referralNoteField('', referralForm.epdIrydsc)}
            <Box my={8}></Box>
          </GridLeft>
        </GridSection>
        <GridSection mx={2} container spacing={1}>
          <ReferralFieldGrid xs={6} title="STOP Rep Name : " defaultValue={referralForm.sTOPPlacementCoordinator?.key} />

          <ReferralFieldGrid
            xs={6}
            title="SASCA Rep Title : "
            defaultValue="Placement Coordinator"
          />

          <ReferralFieldGrid
            xs={6}
            title="STOP Rep Signature : "
            defaultValue=""
          />

          <ReferralFieldGrid xs={6} title="Date : " defaultValue="" />
        </GridSection>
      </Grid>
    </Dialog>
  );
};

export default InitialReferalPage;

InitialReferalPage.defaultProps = {
  open: false,
  setOpen: () => {},
};

InitialReferalPage.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};
